import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import DestinationDetail from './pages/DestinationDetail';
import PopularDestinations from './pages/PopularDestinations';
import Contact from './pages/Contact';
import BalloonAnimation from './components/BalloonAnimation';
import WhatsAppButton from './components/WhatsAppButton';
// import Navbar from './components/Navbar';
// import Footer from './components/Footer';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const main = document.querySelector('main');
    if (main) {
      main.scrollTop = 0;  // ✅ Scroll only main
    }
  }, [pathname]);

  return null;
};

const AppContent = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isDestinationDetail = location.pathname.startsWith('/destination');
  const showBalloons = !(isDestinationDetail && isMobile);

  return (
    <>
      <ScrollToTop />
      {showBalloons && <BalloonAnimation />}
      <WhatsAppButton />

      <main style={{ overflowY: 'auto', flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/PopularDestinations" element={<PopularDestinations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/destination/:id" element={<DestinationDetail />} />
        </Routes>
      </main>

    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
